<template>
  <div>
    <vs-card class="mb-6">
      <form role="form" @submit.stop.prevent="buscar">
        <div :class="`vx-row ${filtroAvancado ? 'pb-10' : 'pb-6 mb-0'}`">
          <!-- Protocolo -->
          <div class="vx-col lg:w-2/12 w-full">
            <span>Protocolo</span>
            <AutoComplete
              size="large"
              customClass="w-full"
              name="codigo"
              id="codigo"
              :configAutoComplete="{ model: 'Eventos', field: 'protocolo' }"
              v-model="formFiltro.idEvento"
            />
          </div>

          <!-- Nome -->
          <div :class="`vx-col lg:w-1/3 w-full`">
            <span>Nome</span>
            <AutoComplete
              size="large"
              customClass="w-full"
              name="Nome"
              id="Nome"
              :configAutoComplete="{ model: 'Eventos', field: 'nome' }"
              v-model="formFiltro.nome"
            />
          </div>

          <!-- CPF / CNPJ -->
          <div class="vx-col lg:w-1/6 w-full">
            <span>CPF / CNPJ</span>
            <AutoComplete
              size="large"
              customClass="w-full"
              name="Cpf Cnpj"
              id="Cpf Cnpj"
              v-model="formFiltro.cpfCnpj"
              :configAutoComplete="{ model: 'Associados', field: 'cpfcnpj' }"
              :minimumCharacters="3"
            />
          </div>

          <div class="lg:flex vx-col lg:w-1/3 gap-5 w-full">
            <!-- Placa -->
            <div :class="`vx-col lg:w-1/3 w-full`">
              <span>Placa</span>
              <AutoComplete
                size="large"
                customClass="w-full"
                name="Placa"
                id="Placa"
                :configAutoComplete="{ model: 'Eventos', field: 'placa' }"
                v-model="formFiltro.placa"
              />
            </div>

            <!-- Chassi -->
            <div :class="`vx-col lg:w-2/3 w-full`">
              <span>Chassi</span>
              <AutoComplete
                size="large"
                customClass="w-full"
                name="Chassi"
                id="Chassi"
                v-mask="'XXXXXXXXXXXXXXXXX'"
                :configAutoComplete="{ model: 'Eventos', field: 'chassi' }"
                v-model="formFiltro.chassi"
              />
            </div>
          </div>
        </div>

        <div v-if="filtroAvancado == true">
          <div class="vx-row pb-10">
            <div class="vx-col lg:w-1/2 w-full">
              <span>Data de cadastro do evento</span>
              <div class="flex flex-row gap-2 w-full">
                <datepicker
                  :format="'dd/MM/yyyy'"
                  placeholder="DD/MM/YYYY"
                  v-model="formFiltro.dataCadastroEventoInicio"
                  class="w-full"
                ></datepicker>
                <datepicker
                  :format="'dd/MM/yyyy'"
                  placeholder="DD/MM/YYYY"
                  v-model="formFiltro.dataCadastroEventoFinal"
                  class="w-full"
                ></datepicker>
              </div>
            </div>
            <!-- Status -->
            <div class="vx-col lg:w-1/4 w-full">
              <span>Status do Evento</span>
              <v-select
                :options="status"
                name="Status"
                id="Status"
                class="input-uppercase"
                v-model="formFiltro.idStatus"
                :reduce="(item) => item.id"
              ></v-select>
            </div>

            <!-- Tipo Evento -->
            <div class="vx-col lg:w-1/4 w-full">
              <span>Motivo do Evento</span>
              <v-select
                :options="tiposEvento"
                name="Tipo"
                id="Tipo"
                class="input-uppercase"
                v-model="formFiltro.idMotivo"
                :reduce="(item) => item.id"
              ></v-select>
            </div>
          </div>

          <div class="vx-row pb-10">
            <!-- Analista do Beneficiário-->
            <div class="vx-col lg:w-1/2 w-full">
              <span>Analista Responsável</span>
              <v-select
                :options="listUsuarios"
                name="UsuarioAnalista"
                id="UsuarioAnalista"
                class="input-uppercase"
                v-model="formFiltro.idAnalistaResponsavel"
                :reduce="(item) => item.id"
              ></v-select>
            </div>

            <!-- Analista -->
            <div class="vx-col lg:w-1/2 w-full">
              <span>Regulador Responsável</span>
              <v-select
                :options="listUsuarios"
                name="UsuarioRegulador"
                id="UsuarioRegulador"
                class="input-uppercase"
                v-model="formFiltro.idReguladorResponsavel"
                :reduce="(item) => item.id"
              ></v-select>
            </div>
          </div>

          <div class="vx-row pb-10">
            <!-- Estado -->
            <div class="vx-col lg:w-1/3 w-full">
              <span>Estado</span>
              <v-select
                :options="estados"
                name="Estado"
                id="Estado"
                v-model="formFiltro.estado"
                :reduce="(item) => item.label"
              ></v-select>
            </div>

            <!-- Cidade -->
            <div class="vx-col lg:w-1/3 w-full">
              <span>Cidade</span>
              <v-select
                :options="cidades"
                name="Cidade"
                id="Cidade"
                class="input-uppercase"
                v-model="formFiltro.cidade"
                :reduce="(item) => item.label"
              ></v-select>
            </div>

            <!-- Regional -->
            <div :class="`vx-col lg:w-1/3 w-full`">
              <span>{{ $t('Regional') }}</span>
              <v-select
                :options="listRegionais"
                name="Regional"
                id="Regional"
                v-model="formFiltro.idRegional"
                :reduce="(item) => item.id"
              ></v-select>
            </div>
          </div>
        </div>
      </form>

      <div slot="footer" style="margin-top: -3%">
        <br style="clear: both" />
        <vs-row vs-justify="flex-end">
          <!-- Buscar -->
          <vs-button
            color="success"
            type="filled"
            icon-pack="feather"
            icon="icon-search"
            class="mr-3 mb-2"
            @click="buscar"
            >Buscar</vs-button
          >

          <!-- Filtro Avançado -->
          <vs-button
            @click="filtroAvancado = !filtroAvancado"
            type="gradient"
            color="dark"
            icon-pack="feather"
            icon="icon-sliders"
          ></vs-button>

          <!-- Limpar Filtro -->
          <vs-button
            @click="limparFiltro"
            color="danger"
            type="gradient"
            icon-pack="feather"
            icon="icon-trash-2"
          ></vs-button>
        </vs-row>
      </div>
    </vs-card>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import * as lang from 'vuejs-datepicker/src/locale';
import vSelect from 'vue-select';
import AutoComplete from './../../../../../components/autocomplete/AutoComplete.vue';
import jwt from 'jsonwebtoken';

// Service
import service from './../../../../../services';
import seviceEventos from './../../shared/service';
import notify from './../../../../../utils/notify';
import { decryptData } from './../../../../../services/decryptData';
import functions from '../../../../../utils/functions';

const formFiltro = {
  placa: null,
  chassi: null,
  nome: null,
  cpfCnpj: '',
  idStatus: null,
  cidade: '',
  estado: '',
  dataCadastroEventoInicio: null,
  dataCadastroEventoFinal: null,
  idEvento: null,
  idMotivo: null,
  idAnalistaResponsavel: null,
  idReguladorResponsavel: null,
  idRegional: null,
};

export default {
  components: {
    Datepicker,
    'v-select': vSelect,
    AutoComplete,
  },
  watch: {
    async 'formFiltro.estado'() {
      this.formFiltro.cidade = null;
      await this.buscaDadosSelectsCidades();
    },
    async filtroAvancado(value) {
      if (value && !this.status.length) {
        try {
          this.$vs.loading();

          await this.buscaDadosSelects('domUf', 'estados', 'nomeUf', 'codUf');
          await this.buscaDadosSelects(
            'eventosSituacoes',
            'status',
            'nomeStatus',
            'idStatus',
          );
          await this.buscaDadosSelects(
            'eventosMotivos',
            'tiposEvento',
            'nomeMotivo',
            'idMotivo',
          );
          await this.buscaDadosSelectsUsuario();
          await this.getRegionalsFilter();
        } catch (error) {
          notify.notifyFail(this.$vs, error);
        } finally {
          this.$vs.loading.close();
        }
      }
    },
  },
  computed: {
    maskCPFCNPJ() {
      return this.formFiltro.cpfCnpj.length <= 14
        ? '###.###.###-##'
        : '##.###.###/####-##';
    },
  },
  data() {
    return {
      languages: lang.ptBR,
      filtroAvancado: false,
      estados: [],
      cidades: [],
      regionais: [],
      status: [],
      tiposEvento: [],
      listUsuarios: [],
      listRegionais: [],

      formFiltro: { ...formFiltro },
    };
  },
  methods: {
    async buscaDadosSelects(model, array, campoDescricao, campoPK) {
      try {
        let res = await service.getAll('g', {}, `${model}/list/`);
        res.data = decryptData(res.data);
        res.data.forEach((element) => {
          if (!element.deletedAt) {
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
          }
        });
      } catch (error) {
        notify.notifyFail(this.$vs, error);
        return Promise.reject(error);
      }
    },
    cleanString(str) {
      str = str.replace(/[áàâãä]/g, 'a');
      str = str.replace(/[éèêë]/g, 'e');
      str = str.replace(/[íìîï]/g, 'i');
      str = str.replace(/[óòôõö]/g, 'o');
      str = str.replace(/[úùûü]/g, 'u');
      str = str.replace(/[ç]/g, 'c');

      return str.toUpperCase();
    },
    async buscaDadosSelectsCidades() {
      try {
        this.$vs.loading();
        this.cidades = [];

        await this.buscaDadosSelects(
          'domMunicipio',
          'cidades',
          'nomeCidade',
          'idCidade',
        );
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    async buscaDadosSelectsUsuario() {
      try {
        this.$vs.loading();
        this.listUsuarios = [];

        const res = await seviceEventos.getListUsuarios();
        this.listUsuarios = res;
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    async getRegionalsFilter() {
      try {
        this.$vs.loading();
        if (!this.decoded || !this.decoded.id_empresa) {
          throw new Error('ID da empresa não encontrado.');
        }

        const companyId = this.decoded.id_empresa;

        const response = await service.get(
          `eventos2`,
          `${companyId}/get-filter-regionals`,
        );

        if (!response && !response.length) {
          throw new Error(`Resposta inválida do servidor: ${response}`);
        }

        this.listRegionais = response.map((regional) => ({
          id: regional.regionalId,
          label: regional.name,
        }));
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Falha ao buscar filtros de regionais',
          text: error.message || 'Resposta inválida do servidor',
          color: 'danger',
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async buscaDadosFiltros() {
      try {
        this.$vs.loading();

        await service
          .post('cotacao', 'busca-filtros-consultores-regionais', this.decoded)
          .then(({ data }) => {
            data.regionais.forEach((element) => {
              this.listRegionais.push({
                id: element.idRegional,
                label: element.nome,
              });
            });
          });
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Falha ao buscar filtros',
          text: error,
          color: 'danger',
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    buscar() {
      this.$emit('filtro', this.formFiltro);
    },
    limparFiltro() {
      this.formFiltro = { ...formFiltro };
      this.buscar();
    },
    getDecoded() {
      const token = localStorage.getItem('user-token');
      if (token) this.decoded = jwt.decode(token);
    },
  },
  created() {
    this.getDecoded();
  },
  mounted() {
    this.$i18n.locale = functions.setLocaleBasedOnCompany();
  },
};
</script>

<style>
.vs__dropdown-toggle {
  padding: 4px 0 6px 0 !important;
}

input.flatpickr-input {
  width: 100%;
}

.vdp-datepicker input {
  width: 100%;
}

.vdp-datepicker__calendar {
  z-index: 900 !important;
}
.input-uppercase input {
  text-transform: uppercase;
}
</style>
